import React from "react";
import { withDefaults } from "../../utils/withDefaults";

export interface AProps {
  href?: string;
  target?: string;
  rel?: string;
  className?: string;
  children?: React.ReactNode;
}

export default function A(incomingProps: AProps) {
  const props = withDefaults(incomingProps, aDefaultProps);

  return (
    <a
      className={props.className}
      href={props.href}
      target={props.target}
      rel={props.rel}
    >
      {props.children}
    </a>
  );
}

const aDefaultProps = {
  href: "",
  target: "_blank",
  rel: "noopener noreferrer",
  className: ""
};
